export const SIMPLE = "SIMPLE";
export const FOTOXISOBOT = "FOTOXISOBOT";
export const SMS = "SMS";
export const SERVICES = "SERVICES";
export const HISOBOT = "HISOBOT";
